export default __webpack_public_path__ + "static/media/onboardingBg.25bc9c80.png";